// log the pageview with their URL
export const pageview = (url) => {
  if (!window.gtag) return
  window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
    // eslint-disable-next-line camelcase
    page_path: url
  })
}

// log specific events happening.
export const event = ({ action, params }) => {
  if (!window.gtag) return
  window.gtag('event', action, params)
}

/**
 * setConfig sets gtag config for all succeeding events
 *
 * @param {[key: string, value: string]} options
 * @returns
 */
export const setConfig = ({ key, value }) => {
  if (!window.gtag) return
  window.gtag('set', {
    [key]: value
  })
}
